(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-partnerships"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      var form=root.querySelector('#BrandPartnershipForm');
      if(!form||form.dataset.enhanced==='true'||root.querySelector('[data-form-success]'))return;
      form.dataset.enhanced='true';
      var steps=Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
      var back=form.querySelector('[data-back]');
      var next=form.querySelector('[data-next]');
      var submit=form.querySelector('[data-submit]');
      var progress=form.querySelector('[data-progress-bar]');
      var currentLabel=form.querySelector('[data-current-step]');
      var stepName=form.querySelector('[data-step-name]');
      var message=form.querySelector('[data-validation-message]');
      var choiceRequiredMessage=form.querySelector('[data-choice-required-message]').textContent;
      var summary=form.querySelector('[data-application-summary]');
      var current=0;
      function show(index,focus){
        current=index;
        steps.forEach(function(step,i){step.hidden=i!==current;});
        back.hidden=current===0;
        next.hidden=current===steps.length-1;
        submit.hidden=current!==steps.length-1;
        progress.style.width=((current+1)/steps.length*100)+'%';
        currentLabel.textContent=String(current+1);
        stepName.textContent=steps[current].dataset.stepLabel||'';
        message.textContent='';
        if(focus){steps[current].focus({preventScroll:true});steps[current].scrollIntoView({behavior:'smooth',block:'start'});}
      }
      function validateStep(){
        var fields=Array.prototype.slice.call(steps[current].querySelectorAll('input,select,textarea'));
        var invalid=fields.find(function(field){return !field.checkValidity();});
        fields.forEach(function(field){field.setAttribute('aria-invalid',field.checkValidity()?'false':'true');});
        if(invalid){message.textContent=invalid.validationMessage;invalid.reportValidity();invalid.focus();return false;}
        var emptyGroup=Array.prototype.slice.call(steps[current].querySelectorAll('[data-required-choice]')).find(function(group){return !group.querySelector('input:checked');});
        if(emptyGroup){message.textContent=choiceRequiredMessage;emptyGroup.querySelector('input').focus();return false;}
        return true;
      }
      function buildSummary(){
        var lines=['MICROCEMENT USA BRAND PARTNERSHIP APPLICATION',''];
        Array.prototype.slice.call(form.elements).forEach(function(field){
          if(!field.name||field===summary||field.type==='submit'||field.type==='button'||field.type==='hidden'||(field.type==='checkbox'&&!field.checked))return;
          var label=form.querySelector('label[for="'+field.id+'"]');
          var key=label?label.textContent.replace(/\s*\*\s*$/,'').trim():field.name.replace(/^contact\[|\]$/g,'').replace(/_/g,' ');
          var value=field.type==='checkbox'?field.value:(field.value||'').trim();
          if(value)lines.push(key+': '+value);
        });
        summary.value=lines.join('\n');
      }
      next.addEventListener('click',function(){if(validateStep())show(Math.min(current+1,steps.length-1),true);});
      back.addEventListener('click',function(){show(Math.max(current-1,0),true);});
      form.addEventListener('input',function(event){if(event.target.matches('input,select,textarea'))event.target.removeAttribute('aria-invalid');});
      form.addEventListener('submit',function(event){if(!validateStep()){event.preventDefault();return;}buildSummary();submit.disabled=true;submit.setAttribute('aria-busy','true');});
      show(0,false);
    }
    document.querySelectorAll('[data-brand-partnerships]').forEach(init);
    document.addEventListener('shopify:section:load',function(event){var root=event.target.querySelector('[data-brand-partnerships]');if(root)init(root);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
